<template>
  <div id="app">
    <commonhead :active_menu="2" :show_type="2" :bg="bg" />
    <div class="teacher_detail my_style">
      <div class="content_wrap">
        <p class="flag">
          <span class="name">
            <router-link to="/">首页</router-link>
          </span>
          <span class="next">></span>
          <span class="name">
            <router-link to="/search-teacher">查找老师</router-link>
          </span>
          <span class="next">></span>
          <span class="name">{{teacherData.real_name}}</span>
        </p>
        
        <div class="right_info">
          <div class="teacher_infobox">
            <span class="pic">
                <img :src="teacherData.avatar" class="pic_full" v-if="teacherData.avatar" />
                <div class="avatar_default pic_full" v-if="!teacherData.avatar"></div>
                <button
                  v-if="teacherData.intro_video_url"
                  type="button"
                  class="video_overlay"
                  aria-label="播放视频介绍"
                  @click="openIntroVideo"
                >
                  <span class="video_play_icon"></span>
                </button>
              </span>
              <div class="info">
                <p class="name">{{teacherData.real_name}}</p>
                <div class="teacher_infos">
                  <div class="teacher_info">
                    <div class="icon-sex"></div>
                    <div class="info-box">
                      <div class="info-text">性别</div>
                      <div class="info-value">{{teacherData.gender == 0 ? '女':'男'}}</div>
                    </div>
                  </div>
                  <div class="teacher_info">
                    <div class="icon-year"></div>
                    <div class="info-box">
                      <div class="info-text">教学经验</div>
                      <div class="info-value">{{teacherData.years}}年</div>
                    </div>
                  </div>
                  <div class="teacher_info">
                    <div class="icon-course"></div>
                    <div class="info-box">
                      <div class="info-text">课时</div>
                      <div class="info-value">{{teacherData.lesson_count}}</div>
                    </div>
                  </div>
                </div>
                <div class="teacher-tagbox">
                  <div class="icon-tag"></div>
                  <div class="teacher-tags">
                    <div class="teacher-tagtext">标签</div>
                    <div class="teacher-tagvalue" v-if="teacherData.labels">
                      <span v-for="(itemIn,index) in JSON.parse(teacherData.labels)" :key="index+'labels'">
                        {{itemIn}}
                        <span v-if="index < JSON.parse(teacherData.labels).length-1">、</span>
                      </span>
                    </div>
                  </div>
                </div>
                
              </div>
          </div>
          <!--个人说明-->
          <div class="personal_info">
            <p class="title">个人说明</p>
            <p class="icon_menu">
              <span class="en_icon hand_point en_active" v-if="en" @click="change_lag(0)">
                英文
              </span>
              <span class="en_icon hand_point" v-if="!en" @click="change_lag(0)">
                英文
              </span>
              <span class="zh_icon hand_point" v-if="en" @click="change_lag(1)">
                中文
              </span>
              <span class="zh_icon hand_point zh_active" v-if="!en" @click="change_lag(1)">
                中文
              </span>
            </p>
            <div class="divider"></div>
            <div
              class="summary"
              v-if="en"
            >{{teacherData&&teacherData.introduction&&JSON.parse(teacherData.introduction) ? JSON.parse(teacherData.introduction).en:""}}</div>
            <div
              class="summary"
              v-if="!en"
            >{{teacherData&&teacherData.introduction&&JSON.parse(teacherData.introduction) ? JSON.parse(teacherData.introduction).zh:""}}</div>
          </div>
          <!--老师简历-->
          <div class="personal_info">
            <p class="title">个人简历</p>
            <div class="divider dif"></div>
            <div
              class="item"
              v-for="(item,index) in (teacherData?teacherData.education?JSON.parse(teacherData.education):[]:[])"
              :key="index+'education'"
            >
              <p class="jl_title">
                <span class="icon">
                  <img src="../../assets/image/search_teacher/new/icon (4).png" alt class="pic_full" />
                </span>
                <span class="titletext">教育经历</span>
                <span class="validicon">
                  <img src="../../assets/image/search_teacher/new/icon (1).png" alt class="pic_full" />
                </span>
                <span class="validtext">已验证</span>
              </p>
              <span class="item_show item_show1">{{item.start}} —— {{item.end}}</span>
              <span class="item_show item_show2">{{item.title}}</span>
              <span class="item_show item_show3" :title="item.sub_title">{{item.sub_title}}</span>
            </div>
            <div
              class="item"
              v-for="(item,index) in (teacherData?teacherData.experience?JSON.parse(teacherData.experience):[]:[])"
              :key="index+'experience'"
            >
              <p class="jl_title">
                <span class="icon">
                  <img src="../../assets/image/search_teacher/new/icon (2).png" alt class="pic_full" />
                </span>
                <span class="titletext">工作经历</span>
                <span class="validicon">
                  <img src="../../assets/image/search_teacher/new/icon (1).png" alt class="pic_full" />
                </span>
                <span class="validtext">已验证</span>
              </p>
              <span class="item_show item_show1">{{item.start}} —— {{item.end}}</span>
              <span class="item_show item_show2">{{item.title}}</span>
              <span class="item_show item_show3" :title="item.sub_title">{{item.sub_title}}</span>
            </div>
            <div
              class="item"
              v-for="(item,index) in (teacherData?teacherData.certification?JSON.parse(teacherData.certification):[]:[])"
              :key="index+'certification'"
            >
              <p class="jl_title">
                <span class="icon">
                  <img src="../../assets/image/search_teacher/new/icon (5).png" alt class="pic_full" />
                </span>
                <span class="titletext">资历证书</span>
                <span class="validicon">
                  <img src="../../assets/image/search_teacher/new/icon (1).png" alt class="pic_full" />
                </span>
                <span class="validtext">已验证</span>
              </p>
              <span class="item_show  item_show1">{{item.start}} —— {{item.end}}</span>
              <span class="item_show item_show2">{{item.title}}</span>
              <span class="item_show item_show3" :title="item.sub_title">{{item.sub_title}}</span>
            </div>
          </div>
          <!-- 评分标签 -->
          <div class="personal_info personal-tag">
            <div class="">评分标签</div>
            <div class="divider dif"></div>
            <div class="tag_items">
              <div class="tag_item">
                <div class="tag_num tag1" :title="teacher_tags['有趣的']">{{teacher_tags['有趣的']?teacher_tags['有趣的']:0}}</div>
                <div class="icon-tag icon-tag1"></div>
                <div class="tag-text">有趣的</div>
              </div>
              <div class="tag_item">
                <div class="tag_num tag2" title="teacher_tags['激励大师']">{{teacher_tags['激励大师']?teacher_tags['激励大师']:0}}</div>
                <div class="icon-tag icon-tag2"></div>
                <div class="tag-text">激励大师</div>
              </div>
              <div class="tag_item">
                <div class="tag_num tag3" title="teacher_tags['擅长会话']">{{teacher_tags['擅长会话']?teacher_tags['擅长会话']:0}}</div>
                <div class="icon-tag icon-tag3"></div>
                <div class="tag-text">擅长会话</div>
              </div>
              <div class="tag_item">
                <div class="tag_num tag4" title="teacher_tags['擅长教孩子']">{{teacher_tags['擅长教孩子']?teacher_tags['擅长教孩子']:0}}</div>
                <div class="icon-tag icon-tag4"></div>
                <div class="tag-text">擅长教孩子</div>
              </div>
              <div class="tag_item">
                <div class="tag_num tag5" title="teacher_tags['超出预期']">{{teacher_tags['超出预期']?teacher_tags['超出预期']:0}}</div>
                <div class="icon-tag icon-tag5"></div>
                <div class="tag-text">超出预期</div>
              </div>
              <div class="tag_item">
                <div class="tag_num tag6" title="teacher_tags['文化视角']">{{teacher_tags['文化视角']?teacher_tags['文化视角']:0}}</div>
                <div class="icon-tag icon-tag6"></div>
                <div class="tag-text">文化视角</div>
              </div>
            </div>
          </div>
          <!--学员评论-->
          <div class="personal_info personal_infofix">
            <p class="title">学员评论</p>
            <div class="divider dif"></div>
            <div class="item" v-for="(item,index) in commentLists.data" :key="index+'comment'">
              <span class="av">
                <img :src="item.student.avatar" alt class="pic_full" />
              </span>
              <div class="comment">
                <p class="comment_star">
                  <span class="comment_name">{{item.student.name}}</span>
                  <span class="star_img" v-for="rateindex of item.rate" :key="rateindex+'star'">
                    <img src="../../assets/image/search_teacher/new/icon-star.png" alt class="pic_full" />
                  </span>
                </p>
                <div
                  class="comment_content"
                >{{item.content}}</div>
                <p class="date">{{item.created_at}}</p>
              </div>
            </div>
            <!--分页器-->
            <div class="pagination pr" v-if="commentLists.total>0">
              <Pagination
                background
                @current-change="getComments"
                layout="total, prev, pager, next"
                :total="commentLists.total"
              >></Pagination>
            </div>
          </div>
        </div>
        <div class="left_info">
          <p class="course_name">专业课程</p>
          <p class="course_info">（一节课）</p>
          <div class="score">
            <p class="cost">
              <span class="num">{{teacherData.price}}</span>
              学贝（{{teacherData.price}}人民币）
            </p>
            <div class="star">
              <span class="icon" v-if="teacherData.score >= 1">
                <img src="../../assets/image/search_teacher/new/icon-star.png" class="pic_full" />
              </span>
              <span class="icon" v-if="teacherData.score >= 2">
                <img src="../../assets/image/search_teacher/new/icon-star.png" alt class="pic_full" />
              </span>
              <span class="icon" v-if="teacherData.score >= 3">
                <img src="../../assets/image/search_teacher/new/icon-star.png" alt class="pic_full" />
              </span>
              <span class="icon" v-if="teacherData.score >= 4">
                <img src="../../assets/image/search_teacher/new/icon-star.png" alt class="pic_full" />
              </span>
              <span class="icon" v-if="teacherData.score >= 5">
                <img src="../../assets/image/search_teacher/new/icon-star.png" alt class="pic_full" />
              </span>
            </div>
            <button class="month_point" @click="monthShow">每月固定预约</button>
            <button
              :class="(free_course != 0 && teacherData.has_free == '1') ? 'apply_now hand_point free':'apply_now hand_point'"
              @click="show_cal(0)"
            >{{(free_course != 0 && teacherData.has_free == '1') ? '免费预约':'立即预约'}}</button>
          </div>
        </div>
      </div>
      <!-- <div class="next_teacher">
        <div class="previous hand_point">
          <div class="icon_wrap">
            <span class="icon">
              <img src="../../assets/image/search_teacher/btn (7).png" alt class="pic_full" />
            </span>
          </div>
          <div class="info_area">
            <span class="name">Kerly</span>
            <br />
            <span class="info">优秀教师</span>
          </div>
        </div>
        <div class="next hand_point">
          <div class="info_area">
            <span class="name">Kerly</span>
            <br />
            <span class="info">优秀教师</span>
          </div>
          <div class="icon_wrap dif">
            <span class="icon">
              <img src="../../assets/image/search_teacher/btn (8).png" alt class="pic_full" />
            </span>
          </div>
        </div>
      </div>-->
      <div class="choose_time" v-if="bg_model_copy" v-show="bg_model" id="bg" ref="calendar">
        <div class="content">
          <p class="title">
            请选择预约时间
            <i class="fr el-icon-close hand_point" @click="show_cal(1)"></i>
          </p>
          <div class="table">
            <FullCalendar
              :key="calendarKey"
              :events="events"
              :config="config"
              class="fc"
              locale="fr"
              @event-selected="eventDrop"
            ></FullCalendar>
          </div>
          <div class="btns">
            <Button type="danger" @click="show_cal(1)">取消</Button>
            <Button type="success" @click="first_submit">提交</Button>
          </div>
        </div>
      </div>
      <div class="choose_time" v-show="confirm_model" id="bg">
        <div class="content_choose">
          <p class="title">
            请确认选课
            <i class="fr el-icon-close hand_point" @click="show_confirm(1)"></i>
          </p>
          <div class="info">
            <p class="title">当前已选择课程时间，请先确认</p>
            <div class="item" v-for="(item,index) in choose_course" :key="index+'course'">{{index+1}}. 上课时间：{{item.time}}</div>
            <!-- <p class="title" style="margin-top:30px;margin-bottom:10px">请选择一种上课方式</p>
            <Radio v-model="radio" label="1">鲸贝在线教室</Radio> -->
          </div>
          <div class="btns">
            <Button type="danger" @click="show_confirm(1)">取消</Button>
            <Button type="success" @click="fin_submit">下单</Button>
          </div>
        </div>
      </div>
      <!-- 固定预约 -->
      <div class="monthtime_modal common-modal" v-if="monthtimemodal">
        <div class="modal-content">
          <div class="icon-close" @click="monthClose"></div>
          <div class="modal-title">申请和{{teacherData && teacherData.real_name}}老师每周固定上课</div>
          <div class="day_title">请选择星期几？</div>
          <div class="day_items">
            <div class="day_item" v-for="(monthday,index) in monthdayArr" :key="index+'monthday'" :class="monthday.active?'day_item_active':''" @click="monthtimeSelect(index)">
              <div class="icon-common"></div>
              <div class="day_text">{{monthday.text}}</div>
            </div>
          </div>
          <div class="time_title">请选择时间段？</div>
          <div class="time_items">
            <div class="time_item" :class="monthtime.active?'time_item_active':''" v-for="(monthtime,index) in monthtimeArr" :key="index+'monthtime'" @click="monthdaySelect(index)">
              <div class="icon-select"></div>
              <div class="time_text">{{monthtime.text}}（{{monthtime.value}}）</div>
            </div>
          </div>
          <div class="timedetail_title">
            请选择详细时间？
          </div>
          <div class="timedetails">
            <div class="timedetail_item">
              <div class="time_notice">*</div>
              <Select v-model="time_selected" placeholder="请选择" class="time_choose" v-if="monthtimeArr[0].active">
                <Option v-for="item in timemorning" :key="item.value" :label="item.label" :value="item.value"></Option>
              </Select>
              <Select v-model="time_selected" placeholder="请选择" class="time_choose" v-if="monthtimeArr[1].active">
                <Option v-for="item in timenoon" :key="item.value" :label="item.label" :value="item.value"></Option>
              </Select>
              <Select v-model="time_selected" placeholder="请选择" class="time_choose" v-if="monthtimeArr[2].active">
                <Option v-for="item in timenight" :key="item.value" :label="item.label" :value="item.value"></Option>
              </Select>
            </div>
            <!-- <div class="timedetail_item">
              <div class="time_notice"></div>
              <Select v-model="sex" placeholder="请选择" class="time_choose">
                <Option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></Option>
              </Select>
              <div class="timedetail_tip">（需要每次上两次课的选择此项）</div>
            </div> -->
          </div>
          <div class="monthtime_info">本次请求与老师协商通过后，老师的该时间将一直为您保留，如果需要中止，请联系您的助教处理。</div>
          <div class="modal-actions">
            <div class="btn_action btn_action_cancel" @click="monthClose">取消</div>
            <div class="btn_action btn_action_confirm" @click="monthConfirm">确定</div>
          </div>
        </div>
      </div>
      <!--底部信息-->
      <div class="bottombox">
        <commonbottom />
      </div>
      <!--公共底部-->
      <commonfoot />
      <!--公共底部-->
      <div
        class="intro_video_modal"
        v-if="introVideoVisible"
        @click.self="closeIntroVideo"
      >
        <div class="intro_video_dialog">
          <button type="button" class="intro_video_close" @click="closeIntroVideo">×</button>
          <video
            ref="introVideo"
            :src="teacherData.intro_video_url"
            :poster="teacherData.avatar"
            controls
            playsinline
            preload="metadata"
          ></video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { common } from "../../../common.js";
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
import commonbottom from "../common/common_bottom";
import { Pagination, Button, Radio,Select,Option } from "element-ui";
import { FullCalendar } from "vue-full-calendar";
import moment from "moment";
import "fullcalendar/dist/fullcalendar.css";
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot,
    Pagination,
    Button,
    Radio,
    FullCalendar,
    Select,
    Option,
    commonbottom
  },
  data: function() {
    return {
      en: true, //是否展示英文介绍
      teacherData: "",
      introVideoVisible: false,
      bg: "",
      bg_model: false,
      confirm_model: false,
      courseData: "",
      radio: "1",
      is_show: false,
      bg_model_copy: false,
      events: [],
      calendarKey: 0,
      choose_course: [],
      config: {
        firstDay: 1,
        locale: "zh-cn",
        defaultView: "agendaWeek",

        height: "auto",
        header: {
          left: "title",
          center: "",
          right: "prev,today,next"
        },
        /* agenda 模式 */
        allDaySlot: false,
        slotLabelFormat: "H:mm", // axisFormat 'H(:mm)'
        slotLabelInterval: 1,
        slotDuration: "00:30:00",
        minTime: "0:00",
        maxTime: "24:00",
        editable: false,
        selectable: false,
        loading: false,
        /* 设置按钮文字 */
        buttonText: {
          today: "今天"
        }
      },
      free_course: "",
      monthtimemodal: false,
       monthdayArr:[
        {
          text: '星期一',
          value: '1',
          active: false
        },
        {
          text: '星期二',
          value: '2',
          active: false
        },
        {
          text: '星期三',
          value: '3',
          active: false
        },
        {
          text: '星期四',
          value: '4',
          active: false
        },
        {
          text: '星期五',
          value: '5',
          active: false
        },
        {
          text: '星期六',
          value: '6',
          active: false
        },
        {
          text: '星期日',
          value: '0',
          active: false
        }
      ],
      monthtimeArr: [
        {
          text: '上午',
          value: '8:00-12:00',
          active: true
        },
        {
          text: '下午',
          value: '12:00-18:00',
          active: false
        },
        {
          text: '晚上',
          value: '18:00-22:00',
          active: false
        }
      ],
      timemorning: [
        {
          value: '08:00-08:25'
        },
        {
          value: '08:30-08:55'
        },
        {
          value: '09:00-09:25'
        },
        {
          value: '09:30-09:55'
        },
        {
          value: '10:00-10:25'
        },
        {
          value: '10:30-10:55'
        },
        {
          value: '11:00-11:25'
        },
        {
          value: '11:30-11:55'
        },
      ],
      timenoon: [
        {
          value: '12:00-12:25'
        },
        {
          value: '12:30-12:55'
        },
        {
          value: '13:00-13:25'
        },
        {
          value: '13:30-13:55'
        },
        {
          value: '14:00-14:25'
        },
        {
          value: '14:30-14:55'
        },
        {
          value: '15:00-15:25'
        },
        {
          value: '15:30-15:55'
        },
        {
          value: '16:00-16:25'
        },
        {
          value: '16:30-16:55'
        },
        {
          value: '17:00-17:25'
        },
        {
          value: '17:30-17:55'
        }
      ],
      timenight: [
        {
          value: '18:00-18:25'
        },
        {
          value: '18:30-18:55'
        },
        {
          value: '19:00-19:25'
        },
        {
          value: '19:30-19:55'
        },
        {
          value: '20:00-20:25'
        },
        {
          value: '20:30-20:55'
        },
        {
          value: '21:00-21:25'
        },
        {
          value: '21:30-21:55'
        },
      ],
      time_selected: '',
      dayindex: 0,
      commentLists: {},
      teacher_tags: {}
    };
  },
  mounted: function() {
    if (this.$route.query.id) {
      this.get_info(this.$route.query.id);
      this.get_course();
      this.getInfo();
      this.getComments(1);
      this.getTags();
    }
  },
  methods: {
    openIntroVideo() {
      if (!this.teacherData || !this.teacherData.intro_video_url) return;
      this.introVideoVisible = true;
      this.$nextTick(() => {
        const player = this.$refs.introVideo;
        const playResult = player && player.play();
        if (playResult && playResult.catch) playResult.catch(() => {});
      });
    },
    closeIntroVideo() {
      const player = this.$refs.introVideo;
      if (player) player.pause();
      this.introVideoVisible = false;
    },
    eventDrop(e) {
      if (e.backgroundColor == "red") {
        this.$message({
          message: "不能选择该课程",
          type: "error",
          center: true
        });
        return false;
      }
      for (let item of this.events) {
        if (item.id == e.id) {
          item.borderColor = item.borderColor == "yellow" ? "green" : "yellow";
        }
      }
    },
    first_submit() {
      for (let item of this.events) {
        if (item.borderColor == "yellow") {
          this.choose_course.push({
            id: item.id,
            time: item.start
          });
        }
      }
      if (this.choose_course.length == 0) {
        this.$message({
          message: "您还没有选择课程",
          type: "error",
          center: true
        });
        return;
      }
      this.confirm_model = true;
    },
    fin_submit() {
      //预约操作
      let self = this;
      let course_id = [];
      for (let item of this.choose_course) {
        course_id.push(item.id);
      }
      if (this.free_course != 0 && this.teacherData.has_free == "1") {
        if (course_id.length > 1) {
          self.$message({
            message: "免费体验课一次只能预约一节",
            type: "error",
            center: true
          });
          return;
        }
        common.requestFun(
          //免费预约体验课
          self,
          "post",
          "/reservation/exp/create",
          {
            class_tool: 1,
            course_id: course_id[0],
            teacher_id: self.$route.query.id
          },
          res => {
            if (res.data.code == 200) {
              self.$message({
                message: res.data.msg,
                type: "success",
                center: true
              });
              self.choose_course = [];
              self.bg_model = false;
              self.confirm_model = false;
              self.$router.push("/user/course");
            } else {
              if (res.data.msg) {
                self.$message({
                  message: res.data.code == 401 ? "请登录" : res.data.msg,
                  type: "error",
                  center: true
                });
              }
            }
          }
        );
      } else {
        common.requestFun(
          self,
          "post",
          "/reservation/creates",
          {
            class_tool: 1,
            course_id: course_id,
            teacher_id: self.$route.query.id
          },
          res => {
            if (res.data.code == 200) {
              self.$message({
                message: res.data.msg,
                type: "success",
                center: true
              });
              self.choose_course = [];
              self.bg_model = false;
              self.confirm_model = false;
              self.$router.push(
                "./user-order-details?order_id=" + res.data.data.order_id
              );
            } else {
              if (res.data.msg) {
                self.$message({
                  message: res.data.code == 401 ? "请登录" : res.data.msg,
                  type: "error",
                  center: true
                });
              }
            }
          }
        );
      }
    },
    change_lag(type) {
      this.en = type == 0 ? true : false;
    },
    get_info(id) {
      //获取老师列表
      let self = this;
      common.requestFun(self, "get", "/teacher/detail/" + id, {}, res => {
        if (res.data.code == 200) {
          self.teacherData = res.data.data;
          if (
            self.$route.query.play_video == "1" &&
            self.teacherData.intro_video_url
          ) {
            self.openIntroVideo();
          }
        } else {
          if (res.data.msg) {
            self.$message({
              message: res.data.msg,
              type: "error",
              center: true
            });
          }
        }
      });
    },
    get_course() {
      let self = this;
      common.requestFun(
        self,
        "get",
        "/teacher/course/available",
        {
          teacher_id: self.$route.query.id
        },
        res => {
          if (res.data.code == 200 && self.events.length == 0) {
            //全职老师提前1小时能约课，兼职老师提前12小时能约课
            let more_time =
              self.$route.query.is_fulltime == 1 ? 1800 : 1 * 1800;
            const nowTimestamp = Math.round(new Date().getTime() / 1000);
            const nextEvents = res.data.data
              .filter(item => parseInt(item.end) >= nowTimestamp)
              .map(item => {
              return {
                borderColor:
                  (item.start - more_time <
                    Math.round(new Date().getTime() / 1000).toString() ||
                  item.status == 2)
                    ? "red"
                    : "green",
                start: self.getLocalTime(new Date(parseInt(item.start) * 1000)),
                end: self.getLocalTime(new Date(parseInt(item.end) * 1000)),
                id: item.id,
                backgroundColor:
                  (item.start - more_time <
                    Math.round(new Date().getTime() / 1000).toString() ||
                  item.status == 2)
                    ? "red"
                    : "green"
              };
              });
            self.events = nextEvents;
            self.calendarKey += 1;
          } else {
            if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true
              });
            }
          }
        }
      );
    },
    getLocalTime(now) {
      var year = now.getFullYear(); //取得4位数的年份
      var month = now.getMonth() + 1; //取得日期中的月份，其中0表示1月，11表示12月
      var date = now.getDate(); //返回日期月份中的天数（1到31）
      var hour = now.getHours(); //返回日期中的小时数（0到23）
      var minute = now.getMinutes(); //返回日期中的分钟数（0到59）
      var second = now.getSeconds(); //返回日期中的秒数（0到59）
      if (minute == 29) {
        minute = 30;
      }
      return (
        year +
        "-" +
        (month < 10 ? "0" + month.toString() : month.toString()) +
        "-" +
        (date < 10 ? "0" + date.toString() : date.toString()) +
        " " +
        (hour < 10 ? "0" + hour.toString() : hour.toString()) +
        ":" +
        (minute < 10 ? "0" + minute.toString() : minute.toString())
      );
    },
    register() {
      this.bg = Math.random();
    },
    show_cal(type) {
      this.bg_model = type == 0 ? true : false;
      if (type == 0 && !this.is_show) {
        this.is_show = true;
        this.bg_model_copy = true;
      }
    },
    show_confirm(type) {
      if (type == 1) {
        this.choose_course = [];
      }
      this.confirm_model = type == 0 ? true : false;
    },
    getInfo() {
      let self = this;
      common.requestFun(self, "get", "/student/profile", {}, res => {
        if (res.data.code == 200) {
          self.free_course = res.data.data.free_course;
        } else {
          if (res.data.msg && res.data.code == 401) {
            self.$message({
              message: "请登录",
              type: "error",
              center: true,
            });
          }
          self.$router.push("./");
        }
      });
    },
    monthShow(teacher){
      this.monthtimemodal = true;
    },
    monthClose(){
      this.monthtimemodal = false;
    },
    monthtimeSelect(index){
      this.monthdayArr[index].active = !this.monthdayArr[index].active;
    },
    monthdaySelect(index){
      if(this.dayindex==index){
        return;
      }else{
        this.time_selected = '';
      }
      this.monthtimeArr[this.dayindex].active = false;
      this.dayindex = index;
      this.monthtimeArr[index].active = true;
    },
    monthConfirm(){
      let self = this;
      var dayArr = this.monthdayArr.filter(item=>item.active);
      if(dayArr.length==0){
        this.$message({
          message: "请选择星期几",
          type: "error",
          center: true
        });
        return;
      }
      if(!this.time_selected){
        this.$message({
          message: "请选择详细时间",
          type: "error",
          center: true
        });
        return;
      }
      let weekdays = [];
      dayArr.forEach(item => {
        weekdays.push(item.value);
      });
      common.requestFun(
          self,
          "post",
          "/reservation/plan/apply",
          {
            time_range: self.dayindex+1,
            weekdays: weekdays,
            teacher_id: self.$route.query.id,
            specific_time: self.time_selected
          },
          res => {
            if (res.data.code == 200||res.data.code=='ok') {
              self.$message({
                message: res.data.msg,
                type: "success",
                center: true
              });
              self.monthClose()
              self.$router.push('/user/course');
            } else {
              if (res.data.msg) {
                self.$message({
                  message: res.data.code == 401 ? "请登录" : res.data.msg,
                  type: "error",
                  center: true
                });
              }
            }
          }
        );
    },
    getComments(page){
      let self = this;
      common.requestFun(
        self,
        "get",
        "/teacher/"+self.$route.query.id+"/comments",
        {
          page: page,
          pagesize: 10,
        },
        res => {
          if (res.data.code == 200) {
            self.commentLists = res.data.data;
          } else {
            if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true
              });
            }
          }
        }
      );
    },
    getTags(){
      let self = this;
      common.requestFun(
        self,
        "get",
        "/teacher/"+self.$route.query.id+"/tags",
        {},
        res => {
          if (res.data.code == 200) {
            self.teacher_tags = res.data.data;
          } else {
            if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true
              });
            }
          }
        }
      );
    }
  }
};
</script>
<style scoped src="./teacher_details.css"></style>
